import { api } from "../services/apiService";
import { exportTelemetryToCSV } from "./exportTelemetryToCSV";
export async function exportFullTelemetry({
    filters,
    pageSize = 500,
    setProcessing,
    setProgress,
    signal,
    executionId,
    getCurrentExecutionId,
    onError
}) {
    try {
        setProcessing(true);
        setProgress(0);

        let page = 1;
        let totalPages = 1;
        let allData = [];

        do {
            if (signal?.aborted) return;

            if (executionId !== getCurrentExecutionId()) return;

            const response = await api.telemetry.search({
                ...filters,
                Page: page,
                PageSize: pageSize
            });

            if (signal?.aborted) return;
            if (executionId !== getCurrentExecutionId()) return;

            allData = allData.concat(response.data);
            totalPages = response.totalPages;

            const percent = Math.round((page / totalPages) * 100);

            setProgress(percent);

            page++;

        } while (page <= totalPages);

        if (signal?.aborted) return;
        if (executionId !== getCurrentExecutionId()) return;

        exportTelemetryToCSV({
            data: allData,
            filters,
            total: allData.length,
            onError
        });

    } catch (err) {
        if (signal?.aborted) {
            return;
        }

        onError?.("Erro ao exportar os dados. Tente novamente.");

    } finally {
        if (executionId === getCurrentExecutionId()) {
            setProcessing(false);
        }
    }
}

